
enum CommonPermissions {
 VIEW_HOME = "view_home"
}


enum AdminPermissions {
  VIEW_DASHBOARD_A = 'view_dashboard_Admin',
  VIEW_USERS = 'view_users',
  VIEW_CREATE_USER = 'view_create_user',
  VIEW_UPDATE_USER = 'view_update_user',
  VIEW_COHORT = 'view_cohort',
  CREATE_COHORT = 'create_update_cohort',
  VIEW_UPDATE_COHORT = 'view_update_cohort',
  VIEW_SAVE_COHORT = 'view_save_cohort',
  VIEW_DELETE_COHORT = 'view_delete_cohort',
  VIEW_DELETE_USER = 'view_delete_user',
  VIEW_UPLOAD_BATCH = 'view_upload_batch',
}

enum SuperAdminPermissions {
 VIEW_DASHBOARD_SA = "view_dashboard_Super_Admin",
 VIEW_ORGANIZATION = "view_organization",
 CREATE_USER_COMPANY_ADMIN="create_user_company_admin",
 CREATE_USER_COMPANY_MANAGER="create_user_company_manager",
 CREATE_USER_COMPANY_USER="create_user_company_user",
 CREATE_USER_BATCH_ADMIN="create_user_batch_admin",
}

export { SuperAdminPermissions, AdminPermissions, CommonPermissions };
